import script from "./ArrayOf.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArrayOf.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__